export enum InvestorProfileActions {
  reviewInvestorProfile = 'investorProfile:reviewInvestorProfile',
}

export enum PayoutActions {
  reviewPayoutMethod = 'payoutMethod:reviewPayoutMethod',
  followUpPayoutMethod = 'payoutMethod:followupPayoutMethod',
}
